import styled from 'styled-components';
import { primary, primarySoft, bgPrimaryLight, border, textMuted, widthFull, widthResize, heightHeader, widthResizeWithPadding } from '../Resources/Theme';

const Nav = styled.div`
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: 100%;
  background: #fff;
  overflow: hidden;
  transition: .5s;
  box-shadow: none;
  border-right: 1px solid ${border};
  z-index: 99;

  &:hover {
    overflow: auto;
    overflow-x: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
    position: fixed;
    margin-top: ${heightHeader};
  }

  &::-webkit-scrollbar {
    width: .3rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #A3A3A3;
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    width: ${widthFull};
    margin-left: -${props => props.mobile ? '0' : '280'}px;
    overflow: auto;
    overflow-x: hidden;
  }
`;

Nav.Bg = styled.div`
  display; none;
  z-index: 99;

  @media (max-width: 992px) {
    display: ${props => props.mobile ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: ${bgPrimaryLight};
  }
`;
Nav.Title = styled.li`
  height: auto;
  min-height: 26px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : '100%'};
  font-weight: 600;
  font-size: 0.6rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${textMuted};
  padding: 12px 12px 6px;
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : ''};
  span {
    display: ${props => props.resize && !props.resizeOpen ? 'none' : 'block'};
    align-self: center;
  }
  i {
    display: ${props => props.resize && !props.resizeOpen ? 'block' : 'none'};
    align-self: center;
  }

  @media (max-width: 992px) {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    span {
      display: block;
    }
    i {
      display: none;
    }
  }
`;
Nav.Swipe = styled.div`
  display: none;
  position: fixed;
  width: 30px;
  height: 100%;
  z-index: 1;
  
  @media (max-width: 992px) {
    display: block;
  }
`;

/* Start Brand */
Nav.Brand = styled.div`
  color: ${primary};
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: ${heightHeader};
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 0 ${props => props.resize && !props.resizeOpen ? '4' : '10'}px;
  transition: .5s;
  box-shadow: none;
  border-bottom: 1px solid ${border};
  border-right: 1px solid ${border};
  z-index: 1;

  @media (max-width: 992px) {
    padding: 0 20px;
    justify-content: center;
    width: ${widthFull};
  }
`;
Nav.Brand.Link = styled.a`
  align-self: center;
`;
Nav.Brand.Logo = styled.img`
  width: ${props => props.resize && !props.resizeOpen ? '50px' : ''};
  align-self: center;
  transition: .5s;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    display: none;
  }
`;
Nav.Brand.IconSize = styled.div`
  align-self: center;
  padding: 5px;
  cursor: pointer;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'flex'};
  justify-content: center;
  font-size: 1.2rem;

  @media (max-width: 992px) {
    display: none;
  }
`;
Nav.Brand.IconMobile = styled.div`
  align-self: center;
  display: none;
  padding: 5px;
  font-size: 1.2rem;

  @media (max-width: 992px) {
    display: flex;
  }
`;
/* End Brand */

/* Start One Level */
Nav.OneLevel = styled.ul`
  padding: 10px 10px;
  padding-top: 76px;
  list-style: none;
`;
Nav.OneLevel.Item = styled.li`
  padding-bottom: 4px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : '100%'};

  @media (max-width: 992px) {
    width: 100%;
  }
`;
Nav.OneLevel.TitleContent = styled.div`
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'space-between'};
  background: ${props => props.active ? primarySoft : 'transparent'};
  color: ${props => props.active ? primary : textMuted};
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  margin-bottom: 3px;
  min-height: 34px;
  align-items: center;
  font-weight: ${props => props.active ? 600 : 500};
  font-size: 0.75rem;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    background: ${primarySoft};
    color: ${primary};
  }

  @media (max-width: 992px) {
    justify-content: space-between;
  }
`;
Nav.OneLevel.Title = styled.div`
  align-self: center;
  transition: .5s;
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
`;
Nav.OneLevel.IconArrow = styled.span`
  align-self: center;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  transform: ${props => props.active ? 'rotate(225deg)' : 'rotate(135deg)'};
  transition: .5s;
  content: '';
  width: 4px;
  height: 4px;
  border-width: 1px 0 0 1px;
  border-style: solid;
  flex-shrink: 0;

  @media (max-width: 992px) {
    display: inline-block;
  }
`;
Nav.OneLevel.Icon = styled.span`
  margin-right: ${props => props.resize && !props.resizeOpen ? '' : '0.55rem'};
  display: flex;
  width: 16px;
  align-self: center;
  flex-shrink: 0;
  font-size: 0.8rem;

  @media (max-width: 992px) {
    margin-right: 0.55rem;
  }
`;
Nav.OneLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  align-self: center;
  font-size: 0.75rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 992px) {
    display: inline-block;
  }
`;
/* End One Level */

/* Start Second Level */
Nav.SecondLevel = styled.ul`
  list-style: none;
  padding: 0 0 4px 0;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : (props.active ? 'block' : 'none')};
  @media (max-width: 992px) {
    display: ${props => props.active ? 'block' : 'none'};
  }
`;
Nav.SecondLevel.Item = styled.li`
  display: flex;
  justify-content: space-between;
  background: ${props => props.active ? primary : 'transparent'};
  color: ${props => props.active ? '#fff' : textMuted};
  border-left: none;
  box-shadow: none;
  border-radius: 10px;
  padding: 7px 10px;
  cursor: pointer;
  font-weight: ${props => props.active ? 600 : 400};
  margin: 2px 0;
  font-size: 0.75rem;
  white-space: nowrap;

  &:hover {
    background: ${props => props.active ? primary : primarySoft};
    color: ${props => props.active ? '#fff' : primary};
  }
`;
Nav.SecondLevel.Title = styled.div`
  align-self: center;
  transition: .325s;
  display: flex;
  align-items: center;
  height: auto;
  min-width: 0;
`;
Nav.SecondLevel.Icon = styled.span`
  margin-right: 0.65rem;
  align-self: center;
  display: flex;
  width: 5px;
  height: 5px;
  border-radius: 10px;
  border: 1.5px solid currentColor;
  opacity: 0.7;
  flex-shrink: 0;
`;
Nav.SecondLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  font-weight: inherit;
  width: auto;
  align-self: center;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 992px) {
    display: inline-block !important;
  }
`;
/* End Second Level */

export default Nav;